import React from 'react'
import {TrashIcon} from "@heroicons/react/24/solid";

const SelectShopifyBlog = ({
                               shopifyBlogsList,
                               handleDetailChanges,
                               parentForm,
                               attribute,
                               selectLabel = '',
                               noFieldLabel = false,
                               fieldClassName = 'w-full',
                           }) => {

    return (
        <>
            <div
                className={`field-container ${fieldClassName ? fieldClassName : 'w-full'}`}>
                {!noFieldLabel &&
                    <div className="field-label w-full">
                        Shopify Blog
                    </div>
                }
                <select
                    className="input-field-max w-full"
                    id={attribute}
                    name={attribute}
                    value={parentForm[attribute]}
                    onChange={handleDetailChanges}>
                    <option value="">Choose {selectLabel}</option>
                    {shopifyBlogsList?.map((shopifyBlog, index) => (
                        <option key={index}
                                value={shopifyBlog.id}>{shopifyBlog.title}</option>
                    ))}
                </select>
            </div>
        </>
    )
}

export default SelectShopifyBlog
